document.addEventListener('DOMContentLoaded', function(){
  var btn   = document.getElementById('notif-btn');
  var panel = document.getElementById('notif-panel');
  var list  = document.getElementById('notif-list');
  var count = document.getElementById('notif-count');
  var total = document.getElementById('notif-total');
  if(!btn || !panel || !list){ return; }

  var items = list.querySelectorAll('.notif-item').length;
  if (count) {
    count.textContent = items;
    if (items > 0) count.style.display = 'flex';
  }
  if (total) total.textContent = items;

  function openPanel(){
    panel.classList.add('active');
    btn.setAttribute('aria-expanded','true');
  }
  function closePanel(){
    panel.classList.remove('active');
    btn.setAttribute('aria-expanded','false');
  }

  // === 移动端点击跳转逻辑 ===
  btn.addEventListener('click', function(e){
   
    if (window.matchMedia('(max-width: 768px)').matches) {
      window.location.href = '/blogs/news';
      return;
    }
  });


  let hoverTimer;

  btn.addEventListener('mouseenter', function(){
    if (window.matchMedia('(max-width: 768px)').matches) return; 
    hoverTimer = setTimeout(openPanel, 200);
  });

  btn.addEventListener('mouseleave', function(){
    if (window.matchMedia('(max-width: 768px)').matches) return;
    clearTimeout(hoverTimer);
    if (!panel.matches(':hover')) closePanel();
  });

  panel.addEventListener('mouseenter', function(){
    if (window.matchMedia('(max-width: 768px)').matches) return;
    clearTimeout(hoverTimer);
    openPanel();
  });

  panel.addEventListener('mouseleave', function(){
    if (window.matchMedia('(max-width: 768px)').matches) return;
    closePanel();
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closePanel();
  });
});
